import {
  BoardCommonControllerService,
  BoardVo,
} from '@/__generated__/CommonApi';
import { FoBannerControllerService } from '@/__generated__/FrontApi';
import Prev from '@/assets/img/icons/prev_17x29@2x.png';
import Next from '@/assets/img/icons/next_17x29@2x.png';
import BannerImg from '@/assets/img/building-future/mental_health_secret_banner.png';
import BannerImgM from '@/assets/img/building-future/mental_health_secret_banner_m@2x.png';
import Banner1019Hz from '@/assets/img/building-future/mental_health_1019hz_banner.jpg';
import Banner1019HzM from '@/assets/img/building-future/mental_health_1019hz_banner_m.jpg';
import DomesticObj1 from '@/assets/img/building-future/domestic_mental_obj01@2x.jpg';
import DomesticObj1M from '@/assets/img/building-future/domestic_mental_obj01_m@2x.jpg';
import DomesticObj2 from '@/assets/img/building-future/domestic_mental_obj02@2x.jpg';
import DomesticObj2M from '@/assets/img/building-future/domestic_mental_obj02_m@2x.jpg';
import DomesticObj3 from '@/assets/img/building-future/domestic_mental_obj03@2x.jpg';
import DomesticObj3M from '@/assets/img/building-future/domestic_mental_obj03_m@2x.jpg';
import DomesticObj4 from '@/assets/img/building-future/domestic_mental_obj04@2x.jpg';
import DomesticObj4M from '@/assets/img/building-future/domestic_mental_obj04_m@2x.jpg';
import Ebook1 from '@/assets/img/building-future/ebook_cover01.jpg';
import Ebook2 from '@/assets/img/building-future/ebook_cover02.jpg';
import Ebook3 from '@/assets/img/building-future/ebook_cover03.jpg';
import Ebook4 from '@/assets/img/building-future/ebook_cover04.jpg';
import EbookTxt1 from '@/assets/img/building-future/ebook_txt01@2x.png';
import EbookTxt2 from '@/assets/img/building-future/ebook_txt02@2x.png';
import EbookTxt3 from '@/assets/img/building-future/ebook_txt03@2x.png';
import EbookTxt4 from '@/assets/img/building-future/ebook_txt04@2x.png';
import LiteracyObj1 from '@/assets/img/building-future/literacy_obj01@2x.png';
import LiteracyObj2 from '@/assets/img/building-future/literacy_obj02@2x.png';
import LiteracyObj3 from '@/assets/img/building-future/literacy_obj03@2x.png';
import BannerImg2 from '@/assets/img/for-every-child/onmymind_banner.png';
import BannerImgM2 from '@/assets/img/for-every-child/onmymind_bannerM@2x.png';
import Obj1 from '@/assets/img/building-future/onmymind_obj1@2x.png';
import Obj2 from '@/assets/img/building-future/onmymind_obj2@2x.png';
import Obj3 from '@/assets/img/building-future/onmymind_obj3@2x.png';
import Obj4 from '@/assets/img/building-future/onmymind_obj4@2x.png';
import SuggestionObj1 from '@/assets/img/building-future/suggestion_obj01@2x.png';
import SuggestionObj2 from '@/assets/img/building-future/suggestion_obj02@2x.png';
import SuggestionObj3 from '@/assets/img/building-future/suggestion_obj03@2x.png';
import WedoObj1 from '@/assets/img/building-future/wedo_obj01@2x.png';
import WedoObj2 from '@/assets/img/building-future/wedo_obj02@2x.png';
import WedoObj3 from '@/assets/img/building-future/wedo_obj03@2x.png';
import WedoObj4 from '@/assets/img/building-future/wedo_obj04@2x.png';
import IconShare from '@/assets/img/icons/ico_target_blank@2x.png';
import AdminBanner from '@/components/AdminBanner';
import Button from '@/components/Button';
import ButtonMoreView from '@/components/ButtonMoreView';
import { CampaignData } from '@/components/Card/CampaignCard2';
import RelativeBoardCard, {
  NewsData,
} from '@/components/Card/RelativeBoardCard';
import Container from '@/components/Container';
import Row from '@/components/Grid/Row';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import { SectionTop } from '@/components/Nodiscrimination';
import PageComponent from '@/components/PageComponent';
import { ProcessList } from '@/components/ProcessList';
import Section, { SectionNews } from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import SwiperBasic from '@/components/Swiper/SwiperBasic';
import { Tit } from '@/components/Titles';
import BaseBR from '@/components/Typing/BR';
import YoutubeSingle from '@/components/YoutubeSingle';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { navigate, PageProps, Link } from 'gatsby';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Navigation, Scrollbar, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation, Scrollbar, A11y, Autoplay]);

const BR = styled(BaseBR)`
  ${breakpoint('tablet')} {
    display: none;
  }
`;
const itemData = [
  {
    id: 1,
    img: Obj1,
    title: `1/5`,
    desc: [
      {
        dec: `일상에서 자주 우울감을<br /> 느끼는 어린이 비율 1/5`,
      },
    ],
  },
  {
    id: 2,
    img: Obj2,
    title: `11분`,
    desc: [
      {
        dec: `매 11분마다 1명의<br /> 어린이가 스스로 삶을 포기`,
      },
    ],
  },
  {
    id: 3,
    img: Obj3,
    title: `75%`,
    desc: [
      {
        dec: `24세가 되기 전 마음건강 문제가<br /> 생긴 청소년 비율 75%`,
      },
    ],
  },
  {
    id: 4,
    img: Obj4,
    title: `1/4`,
    desc: [
      {
        dec: `전 세계적으로 마음건강 문제가 있는<br /> 부모와 같이 사는 어린이 비율 1/4`,
      },
    ],
  },
];

const bannerData = [
  {
    id: 1,
    imgPC: BannerImg,
    imgM: BannerImgM,
    link: 'https://youtube.com/playlist?list=PLlRQ9rhS-YqqeWX8hbkntulURJVgxtUJz&si=Y3h1QMUZsN2JEcAB',
  },
  {
    id: 2,
    imgPC: Banner1019Hz,
    imgM: Banner1019HzM,
    link: '/campaign/mentalhealth/',
  },
];

const domesticData = [
  {
    id: 1,
    img: DomesticObj1,
    imgM: DomesticObj1M,
    title: `<span>1</span>위`,
    dec: `13년간 10대 사망원인 1위, 자살`,
    source: `- 통계청 「사망원인통계(2011-2024)」`,
  },
  {
    id: 2,
    img: DomesticObj2,
    imgM: DomesticObj2M,
    title: `<span>73</span>%`,
    dec: `자살한 청소년 중 73%가<br /> 위기 징후를 발견하지 못한 ‘침묵군’`,
    source: `- 교육부 「학생 자살 사망사안 보고서(2017-2023)」`,
  },
  {
    id: 3,
    img: DomesticObj3,
    imgM: DomesticObj3M,
    title: `<span>2</span>명 중 <span> 1</span>명`,
    dec: `청소년 2명 중 1명이 ‘자신의 마음을<br /> 이야기 하기 어렵다’고 답함`,
    source: `- 유니세프 한국위원회 「유니세프 마음건강 인식조사(2024)」`,
  },
  {
    id: 4,
    img: DomesticObj4,
    imgM: DomesticObj4M,
    title: `<span>34</span>위`,
    dec: `OECD 36개국 중<br /> 마음건강 순위 34위 `,
    source: `- 유니세프 이노첸티 연구소 「Report Card 19(2025)」`,
  },
];

const ebookData = [
  {
    id: 1,
    img: Ebook1,
    title: EbookTxt1,
    alt: `초등학생을 위한 마음여행일지`,
    link: `https://www.unicef.or.kr/data/upload/ebook/crc-publications/journey-to-my-mind-for-elementary-schoolers`,
  },
  {
    id: 2,
    img: Ebook2,
    title: EbookTxt2,
    alt: `중학생을 위한 마음여행일지`,
    link: `https://www.unicef.or.kr/data/upload/ebook/crc-publications/journey-to-my-mind-for-middle-schoolers`,
  },
  {
    id: 3,
    img: Ebook3,
    title: EbookTxt3,
    alt: `고등학생을 위한 마음여행일지`,
    link: `https://www.unicef.or.kr/data/upload/ebook/crc-publications/journey-to-my-mind-for-high-schoolers`,
  },
  {
    id: 4,
    img: Ebook4,
    title: EbookTxt4,
    alt: `보호자를 위한 마음여행 안내서`,
    link: `https://www.unicef.or.kr/data/upload/ebook/crc-publications/journey-to-my-mind-for-caregivers/`,
  },
];

const suggestionData = [
  {
    id: 1,
    img: SuggestionObj1,
    title: `예방적 접근`,
    desc: [
      {
        dec: `
        국내 마음건강 서비스·정책은 사후 치료에
        집중되어 있습니다. 문제가 발생하기 전
        예방적 지원을 강화해야 합니다.`,
      },
    ],
  },
  {
    id: 2,
    img: SuggestionObj2,
    title: `정책/부서 간 연계`,
    desc: [
      {
        dec: `
        여러 부처와 기관에 분산된 마음건강 정책,
        어린이를 위한 통합적인 마음건강 정책을 마련하고
        지속적인 지원을 제공할 수 있는 체계적 연계가
        필요합니다.`,
      },
    ],
  },
  {
    id: 3,
    img: SuggestionObj3,
    title: `어린이 관점의 정책`,
    desc: [
      {
        dec: `
        국가 자살예방·정신건강 정책에서 어린이는
        보이지 않습니다. 어린이의 특성을 반영한
        맞춤형 전략이 요구됩니다.`,
      },
    ],
  },
];

const wedoData = [
  {
    id: 1,
    img: WedoObj1,
    title: `대중`,
    dec: `어린이가 건강하게 성장할 수 있도록 인식을 <BR />
          변화하고, 지지하고, 실천하는 문화를 만듭니다.`,
    tag: `#양육과돌봄 #긍정적마음건강`,
  },
  {
    id: 2,
    img: WedoObj2,
    title: `교육기관`,
    dec: `어린이가 가장 많은 시간을 보내는 학교에서 <BR />
          마음건강을 배우고 지킬 수 있도록 합니다.`,
    tag: `#사회정서학습 #교사마음건강`,
  },
  {
    id: 3,
    img: WedoObj3,
    title: `기업`,
    dec: `가족친화정책과 투자로 보호자와 <BR />
          어린이 마음건강을 지지하고, 민간 차원의 참여를 <BR />
          기반으로 한 사회 공헌 활동을 추진합니다.`,
    tag: `#가족친화정책 #ESG`,
  },
  {
    id: 4,
    img: WedoObj4,
    title: `정부와 지역사회`,
    dec: `어린이와 가정을 위한 예방 중심의 <BR />
          마음건강 정책과 서비스를 확대합니다.`,
    tag: `#아동친화정책`,
  },
];
const SectionBanner = styled(Section)`
  padding-top: 90px;
`;
const SwiperCustom = styled(SwiperBasic)`
  padding: 0;
  .swiper-container {
    padding-bottom: 0 !important;
    position: relative;

    .swiper-button-prev,
    .swiper-button-next {
      width: 17px;
      height: 29px;
      filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.3));
      box-shadow: none;
      top: 50%;
      bottom: initial;
      margin: 0;
      transform: translateY(-50%);
      background: transparent;

      &::after {
        display: none;
      }
    }

    .swiper-button-prev {
      left: 14px;
      background: url(${Prev}) no-repeat 0 0 / contain;
    }
    .swiper-button-next {
      right: 14px;
      background: url(${Next}) no-repeat 0 0 / contain;
    }
    ${breakpoint(`tablet`)} {
      .swiper-button-prev,
      .swiper-button-next {
        display: block;
        width: 10px;
        height: 17px;
      }
    }

    ${breakpoint(`mobile`)} {
      .swiper-button-prev {
        left: 10px;
      }
      .swiper-button-next {
        right: 10px;
      }
    }
  }
`;
const SectionSort = styled(Section)`
  padding-bottom: 0 !important;

  .sort_source {
    font-size: 14px;
    opacity: 0.5;
    margin-top: 64px;
    text-align: right;
  }

  ${breakpoint(`mobile`)} {
    .process-ol {
      li:nth-child(n + 3):nth-child(-n + 4) {
        br {
          display: none;
        }
      }
    }

    .sort_source {
      font-size: 12px;
      margin-top: 48px;
    }
  }
`;
const SectionDomestic = styled(Section)`
  .domestic-mental-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    li {
      width: calc(50% - 10px);
      min-height: 261px;
      padding: 54px 40px 40px;
      background-color: #e2f0f6;
      background-repeat: no-repeat;
      background-position: 100% 100%;
      background-size: contain;

      .title {
        font-size: 30px;
        font-weight: 700;
        color: #1cabe2;

        span {
          font-size: 48px;
        }
      }
      .dec {
        line-height: 1.6;
        margin: 12px 0 14px;
        min-height: 51px;
      }
      .source {
        font-size: 14px;
        opacity: 0.5;
      }

      ${breakpoint(`tablet`)} {
        padding: 4vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        min-height: auto;

        .title {
          font-size: 3vw;
          span {
            font-size: 4.84vw;
          }
        }
      }
    }
  }

  article {
    margin-top 64px;
    .dec {
      margin-top 32px;
    }
    .recommend-list {
      margin-top: 64px;
      padding: 40px 32px;
      background: #f8f9fa;

      li {
        padding-left: 16px;
        position: relative;
        line-height: 2;

        &::before {
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          background: #2d2926;
          border-radius: 100%;
          position: absolute;
          top: 14px;
          left: 0;
        }

        & + li {
          margin-top: 40px;
        }
      }
    }
  }

  ${breakpoint(`mobile`)} {
    .domestic-mental-list {
      li {
        width: 100%;
        padding: 45px 20px 20px;
        min-height: 180px;

        .title {
          font-size: 16px;
          span {
            font-size: 26px;
          }
        }
        .dec {
          margin: 6px 0 10px;
          min-height: auto;
        }
        .source {
          font-size: 12px;
        }

        &:last-child .dec br {
          display: none;
        }
      }
    }

    article {
      margin-top: 48px;
      .dec {
        margin-top 24px;
      }

      .recommend-list {
        margin-top: 48px;
        padding: 20px 24px;

        li {
          & + li {
            margin-top: 20px;
          }
          &::before {
            top: 12px;
          }
        }
      }
    }
  }
`;
const SectionLiteracy = styled(Section)`
  background: #f8fcfe;

  .ebook-list {
    display: flex;
    justify-content: space-around;

    li {
      text-align: center;
      .ebook_cover {
        box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.1);
      }

      .ebook_title {
        margin-top: 14px;
        img {
          width: 130px;
        }
      }
    }

    ${breakpoint(`tablet`)} {
      flex-wrap: wrap;
      gap: 48px 0;
      li {
        width: 50%;

        a {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .ebook_cover {
          max-height: 183px;
        }
        .ebook_title {
          margin-top: 12px;
          img {
            width: 110px;
          }
        }
      }
    }
  }

  .dec-list {
    margin-top: 96px;
    li {
      line-height: 2;
      position: relative;
      padding-left: 80px;

      & + li {
        margin-top: 32px;
      }

      &::before {
        content: '';
        display: block;
        width: 56px;
        height: 56px;
        position: absolute;
        top: 0;
        left: 0;
        background-size: contain;
        background-repeat: no-repeat;
      }
      &:nth-child(1)::before {
        background-image: url(${LiteracyObj1});
      }
      &:nth-child(2)::before {
        background-image: url(${LiteracyObj2});
      }
      &:nth-child(3)::before {
        background-image: url(${LiteracyObj3});
      }

      strong {
        display: block;
        font-size: 20px;
        margin-bottom: 6px;
      }
    }

    ${breakpoint(`mobile`)} {
      margin-top: 48px;
      font-size: 14px;
      li {
        padding-left: 0;

        & + li {
          margin-top: 24px;
        }

        &::before {
          position: initial;
          margin-bottom: 8px;
        }
        strong {
          font-size: 16px;
        }
      }
    }
  }
`;
const SectionSuggest = styled(Section)`
  padding-bottom: 0 !important;
`;
const SectionWedo = styled(Section)`
  .wedo-list {
    display: flex;
    flex-wrap: wrap;
    gap: 60px 20px;

    li {
      width: calc(50% - 10px);
      display: flex;
      align-items: flex-start;

      .wedo-img {
        width: 120px;
        height: 120px;
        flex-shrink: 0;
        margin-right: 24px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .wedo-txt {
        .title {
          font-size: 20px;
          margin-bottom: 3px;
        }
        .hashtag {
          color: #1cabe2;
          margin-top: 16px;
        }
      }
    }

    ${breakpoint(`tablet`)} {
      li {
        .wedo-img {
          width: 60px;
          height: 60px;
        }
        .wedo-txt {
          .title {
            font-size: 16px;
          }
        }
      }
    }
    ${breakpoint(`mobile`)} {
      gap: 32px 0;
      li {
        width: 100%;

        .wedo-txt {
          .dec {
            br {
              display: none;
            }
          }
          .hashtag {
            margin-top: 8px;
          }
        }
      }
    }
  }
`;
const SingleBanner = styled.div`
  width: 100%;
  padding: 80px 0;
  color: #fff;

  ${Tit} {
    white-space: pre-line;
    ${breakpoint(`mobile`)} {
      white-space: normal;
    }
  }
  .dec {
    margin: 32px 0 40px;
    white-space: pre-line;
  }

  button {
    max-width: 256px;
    width: 100%;
  }

  ${breakpoint(`mobile`)} {
    padding: 60px 0 423px;

    button {
      max-width: 152px;
    }
  }
`;

/* 개행 */
export const normalizeBannerText = (text?: string) => {
  if (!text) return '';
  return text.replace(/\\n/g, '\n');
};

const MentalHealth: React.FC<PageProps> = ({ location, ...props }) => {
  const [slideData, setSlideData] = useState<CampaignData[]>([]);
  const [newsData, setNewsData] = useState<NewsData[]>([]);

  const loadSlideData = useCallback(async () => {
    try {
      const {
        data: childStory,
      } = await BoardCommonControllerService.foListAllUsingGet({
        boardCategoryCode: ['EV01'],
        outDateDispYn: `Y`,
      });
      setSlideData(
        childStory.map((story: BoardVo) => ({
          id: story.boardIndexNumber,
          title: story.subject,
          dec: story.contents,
          image: story.imgAttGrpNoTn,
          pop: `#Love Myself 캠페인 활동`,
          youtube: story.optData1,
          thumYoutube: story.optData2,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadNews = useCallback(async () => {
    try {
      const { data } = await BoardCommonControllerService.foListUsingGet({
        boardCategoryCode: ['280', '285', '290', '300', '295'],
        pagePerCount: 8,
        category: ['A035'],
      });
      const articles = data as any;
      setNewsData(
        articles
          .map((article: BoardVo) => ({
            id: article.boardIndexNumber,
            title: article.subject,
            pcImage: article.imgAttGrpNoTn,
            mobileImage: article.imgAttGrpNoTn,
            link: `/what-we-do/news/${article.boardIndexNumber}`,
            date: article.firstRegisterDate,
            boardCategoryCode: article.boardCategoryCode,
          }))
          .sort((a, b) => new Date(b.date) - new Date(a.date) || b.id - a.id),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  /* 관리자 연동 최신 배너 1개 노출 */
  const [banner, setBanner] = useState([]);
  const loadBanner = useCallback(() => {
    FoBannerControllerService.selectBannerListUsingGet({
      kind: `0005`,
    })
      .then(({ data }) => {
        console.log('banner: ', data);
        const bannerList = Object.values(data);
        if (bannerList.length > 0) {
          setBanner(bannerList[0]);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  /* banner slide */
  const isMultiple = bannerData.length > 1;

  useEffect(() => {
    loadBanner();
  }, [loadBanner]);

  useEffect(() => {
    loadSlideData();
  }, [loadSlideData]);

  useEffect(() => {
    loadNews();
  }, [loadNews]);

  return (
    <LayoutWithTitle
      location={location}
      paddingBtt
      title="마음건강"
      description="for every child, mental health"
    >
      <SectionTop
        className="by-sub-main-layout"
        css={`
          padding-bottom: 0 !important;
        `}
      >
        <Container>
          <SectionHeader
            className="with-desc"
            css={`
              ${breakpoint(`tablet`)} {
                padding-bottom: 94px;
              }
              ${breakpoint(`mobile`)} {
                padding-bottom: 48px;
              }
            `}
          >
            <h2>
              <Tit size="s1-5" color="sky" weight="normal">
                <PageComponent id="title1">
                  마음건강은 사회 전체가 <br />
                  함께 책임져야 합니다
                </PageComponent>
              </Tit>
            </h2>
            <p className="head-dec">
              <PageComponent id="content1">
                전 세계 아동·청소년 중 13%가 마음건강 문제를 겪고 있고, 15~19세
                청소년의 4번째 사망원인은 자살입니다. 마음건강 문제의 절반은
                14세 이전에 시작되며, <BR /> 이때 발생한 마음건강 문제는
                성인까지 이어질 수 있습니다. 따라서 초기 청소년기는 마음건강에
                이상이 생기는 것을 막고 긍정적으로 마음건강을 증진할 수 있는
                중요한 시기입니다. <br /> 또한 어린 시절 경험한 마음건강 문제는
                건강, 교육 결과, 소득 능력에 장기적인 영향을 미칠 수 있으므로,
                조기에 발견하고 예방하는 것이 더욱 중요합니다. <br />
                그래서 유니세프는 마음건강을 치료가 아닌 예방 관점에서 접근하고
                있습니다. 특별히 마음건강을 개인의 문제가 아닌 사회 전체가 함께
                책임져야 할 공공 의제로 알리고, <BR /> 모든 어린이가 안전하게
                마음을 표현하고 회복할 수 있는 건강한 사회적 환경을 만들어가기
                위해 노력합니다.
              </PageComponent>
            </p>
          </SectionHeader>
        </Container>
        <PageComponent id="youtube1">
          <YoutubeSingle videoId="u32a6jo2iL4" />
        </PageComponent>
      </SectionTop>

      <SectionBanner>
        <Container>
          <SwiperCustom overflowHidden {...props}>
            <Swiper
              navigation={isMultiple}
              loop={isMultiple}
              autoplay={{ delay: 3000 }}
              allowTouchMove={isMultiple}
            >
              {bannerData.map((row) => (
                <SwiperSlide key={row.id}>
                  <Link to={row.link} className="banner" target="_blank">
                    <Image pcSrc={row.imgPC} mobileSrc={row.imgM} alt="" />
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </SwiperCustom>
        </Container>
      </SectionBanner>

      <SectionSort className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc sec-header">
            <h2>
              <Tit size="s1">
                세계적으로 심각한
                <br />
                어린이 마음건강 문제
              </Tit>
            </h2>
          </SectionHeader>

          <ProcessList itemData={itemData} />
          <div className="sort_source">
            - 유니세프 「세계아동현황보고서(2021)」
          </div>
        </Container>
      </SectionSort>

      <SectionDomestic className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc sec-header">
            <h2>
              <Tit size="s1">국내는 어떨까요?</Tit>
            </h2>
          </SectionHeader>

          <ul className="domestic-mental-list">
            {domesticData.map((row) => (
              <li
                className="domestic-mental"
                key={row.id}
                css={`
                  background-image: url(${row.img});
                  ${breakpoint(`tablet`)} {
                    background-image: url(${row.imgM});
                  }
                `}
              >
                <div
                  className="title"
                  dangerouslySetInnerHTML={{ __html: row.title }}
                />
                <div
                  className="dec"
                  dangerouslySetInnerHTML={{ __html: row.dec }}
                />
                <div className="source">{row.source}</div>
              </li>
            ))}
          </ul>
          <article>
            <h3>
              <Tit size="s2">국제사회의 권고</Tit>
            </h3>
            <p className="dec">
              유엔아동권리위원회는 5·6차 보고서(2019)를 통해 마음건강과 관련해
              우리나라에 아래와 같이 권고했습니다.
            </p>
            <ul className="recommend-list">
              <li>
                <strong>생명, 생존 및 발달의 권리</strong> <br />
                19. 위원회는 ‘자살예방 국가 행동계획’ 수립에 주목하는 한편,
                대한민국 아동 사망의 주요 원인인 높은 아동 자살률, 특히 가정
                문제, 우울증, 학업 부담, 집단 괴롭힘 등으로 인한 자살에 심각한
                우려를 표한다. 이러한 현상 및 그 근본원인 해결을 위한 체계적인
                접근과 예산이 부재하다는 점과 함께, 위원회는 다음 사항들을
                우려한다.
                <br />…<br />
                20. 위원회는 앞서 권고했듯, 포괄적 정책, 심리적·교육적·사회적
                조치, 아동 및 가족, 나아가 일반 대중을 대상으로 하는 치료를 통해
                아동 자살을 효과적으로 예방하고, <BR />그 근본원인 해결을 위한
                노력을 강화할 것을 당사국에 촉구한다.
              </li>
              <li>
                <strong>정신건강</strong> <br />
                38. 당사국이 아동 자살에 대응하기 위한 조치에 주목하며, 위원회는
                정신 건강과 웰빙 증진에 관한 지속가능발전목표 세부목표 3.4를
                감안하여 자살예방과 <BR />
                그것의 근본원인에 집중하는 것을 포함하여 아동의 정신적 웰빙
                향상을 위한 노력을 지속적으로 강화할 것을 당사국에 반복하여
                권고한다.
              </li>
            </ul>
          </article>
        </Container>
      </SectionDomestic>

      <SectionLiteracy className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc sec-header">
            <h2>
              <Tit size="s1-5" color="sky">
                건강한 성인으로 자라기 위해서는
              </Tit>
              <br />
              <Tit size="s1" color="sky">
                마음건강 문해력이 필요합니다
              </Tit>
            </h2>
          </SectionHeader>
          <ul className="ebook-list">
            {ebookData.map((row) => (
              <li key={row.id}>
                <Link to={row.link} target="_blank">
                  <img src={row.img} alt="ebook" className="ebook_cover" />
                  <div className="ebook_title">
                    <img src={row.title} alt={row.alt} />
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          <ul className="dec-list">
            <li>
              <strong>보호자의 마음건강 문해력 증진</strong>
              보호자의 마음건강은 어린이의 마음건강에 가장 큰 영향을 미칩니다.
              <br />
              가정이 어린이·청소년의 건강한 마음에 1차 백신이 되어줄 수 있기
              때문에 보호자의 마음건강도 매우 중요합니다.
              <br />
              유니세프 한국위원회는 보호자의 마음건강 증진을 위해 마음여행 일지
              「나를 찾는 마음여행」을 개발했습니다.
            </li>
            <li>
              <strong>어린이의 마음건강 문해력 증진</strong>
              마음건강 문제의 예방을 위해서 내 마음이 어떤지 알고, 마음을
              건강하게 유지하는 방법을 알고 적용하며, 필요 시 적절한 도움을
              요청할 수 있는
              <BR />
              마음건강 문해력이 필요합니다. 유니세프 한국위원회는
              초·중·고등학생을 위한 마음건강 문해력 교육 교재를 개발해 전국
              학교를 통해 배포하고 있습니다.
            </li>
            <li>
              <strong>전 세계 어린이의 마음건강 문해력 증진</strong>
              기후변화로 인한 홍수, 지진, 태풍 등의 천재지변, 빈곤, 전쟁 등의
              긴급구호 상황은 어린이 마음건강에 부정적인 결과를 초래합니다.
              <br />
              어린이가 아동친화적인 공간에 머물며 자신의 감정을 알고 충분히
              표현하며 치유받을 수 있도록 다양한 전문가들과 협력하고 있습니다.
            </li>
          </ul>
        </Container>
      </SectionLiteracy>

      <SectionSuggest className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">
                마음건강 증진을 위한 <br />
                유니세프 한국위원회의 3가지 제안
              </Tit>
            </h2>
          </SectionHeader>
          <ProcessList itemData={suggestionData} />
          <div
            css={`
              text-align: center;
              margin-top: 64px;
              ${breakpoint(`mobile`)} {
                margin-top: 48px;
              }
            `}
          >
            <a
              href="/campaign/mentalhealth/"
              target="_blank"
              rel="noopener"
              css={`
                display: inline-flex;
                align-items: center;
                gap: 10px;
                background: #1cabe2;
                color: white;
                text-decoration: none;
                padding: 17px 34px;
                border-radius: 10px;
                font-size: 15.5px;
                font-weight: 700;
                box-shadow: 0 10px 24px rgba(28, 171, 226, 0.32);
                font-family: 'Noto Sans KR', sans-serif;
                transition: transform 0.15s ease, box-shadow 0.15s ease;
                &:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 14px 30px rgba(28, 171, 226, 0.4);
                }
              `}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                <path d="M15 5l4 4" />
              </svg>
              마음건강지원법 서명하기
            </a>
          </div>
        </Container>
      </SectionSuggest>

      <SectionWedo className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1" color="sky">
                여러분이 할 수 있는 일
              </Tit>
            </h2>
          </SectionHeader>
          <ul className="wedo-list">
            {wedoData.map((row) => (
              <li key={row.id}>
                <div className="wedo-img">
                  <img src={row.img} alt={`${row.title} icon`} />
                </div>
                <div className="wedo-txt">
                  <div className="title">
                    <strong>{row.title}</strong>
                  </div>
                  <div
                    className="dec"
                    dangerouslySetInnerHTML={{ __html: row.dec }}
                  />
                  <div className="hashtag">{row.tag}</div>
                </div>
              </li>
            ))}
          </ul>
        </Container>
      </SectionWedo>

      {banner && (
        <SingleBanner
          css={`
            background: url(${banner.imgAttGrpNoPc}) no-repeat 50% 50%;
            background-size: cover;

            ${breakpoint(`mobile`)} {
              background: url(${banner.imgAttGrpNoMobile}) no-repeat 100% 100%;
              background-size: cover;
            }
          `}
        >
          <Container>
            <h2>
              <Tit size="s1-5">{normalizeBannerText(banner.title)}</Tit>
            </h2>
            <p className="dec">{normalizeBannerText(banner.subTitle)}</p>
            <Button
              color="yellow"
              title="후원하기"
              onClick={() => navigate(banner.targetUrl)}
            >
              후원하기
            </Button>
          </Container>
        </SingleBanner>
      )}

      <SectionNews className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <div className="flex-middle">
              <h2>
                <Tit size="s1">최근 소식</Tit>
              </h2>
              <LinkSafe to="/what-we-do/news?category=A035" className="more">
                <span className="txt">더 보기</span>
              </LinkSafe>
            </div>
          </SectionHeader>
          {newsData.length > 0 && (
            <RelativeBoardCard
              newslist={newsData}
              isDate={false}
              isSwiper
              overflowHidden
            />
          )}
        </Container>
      </SectionNews>
    </LayoutWithTitle>
  );
};

export default MentalHealth;
